import { useParams, useNavigate } from 'react-router-dom'
import { useConfig } from '../../hooks/useConfig'
import { useAuth } from '../../hooks/useAuth'
import { decodeConfigId } from '../../helpers/decodeConfigId'
import { buildConfigQuery } from '../../helpers/buildConfigQuery'
import { buildConfigDetailTitle } from '../../helpers/buildConfigDetailTitle'
import { deleteConfig } from '../../services/api/deleteConfig'
import { ConfirmDeleteEntityPage } from '../ConfirmDeleteEntityPage/ConfirmDeleteEntityPage'

export function ConfigDeletePage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { getToken } = useAuth()

  const configFields = id ? decodeConfigId(id) : null
  const query = configFields ? buildConfigQuery(configFields) : ''
  const { configs, isLoading, error } = useConfig(query)

  const config = configFields
    ? configs.find(c =>
        c.configKey === configFields.configKey &&
        c.tenantCode === configFields.tenantCode &&
        c.inventorySystemProfileCode === configFields.inventorySystemProfileCode &&
        c.venueId === configFields.venueId
      ) ?? null
    : null

  const title = config ? buildConfigDetailTitle(config) : ''

  async function handleConfirm() {
    if (!config) return
    const token = await getToken()
    await deleteConfig(token, config.id)
    navigate('/configs')
  }

  return (
    <ConfirmDeleteEntityPage
      entityLabel="Config"
      title={title}
      cancelTo={`/configs/${id}`}
      onConfirm={handleConfirm}
      isLoading={isLoading}
      loadError={error}
    />
  )
}
